import React, { useEffect, useState } from 'react';
import { RuleForm, RuleFormFormState } from '../molecules/RuleForm';
import { useCriteria } from '../../../hooks/Rules/useCriteria';
import useFetchRule from '../../../hooks/Rules/useFetchRule';
import { useRuleAdapter } from '../../../hooks/Rules/useRuleAdapter';
import { editRule } from '../../../services/rulesService';
import Message from '../../../components/atoms/Message/Message';
import { useNavigate } from 'react-router-dom';

interface RuleEditProps {
  ruleId: number;
}

export const EditRuleForm = ({ ruleId }: RuleEditProps) => {
  const { criterias, loadCountriesAndCities, loadServiceCode, loadCities } = useCriteria();
  const { rule } = useFetchRule(ruleId);
  const { parseAPIToForm } = useRuleAdapter();
  const [formState, setFormState] = useState<RuleFormFormState>();
  const [formIsLoading, setFormIsLoading] = useState(false);
  const [errMessage, setErrMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (rule) {
      setFormState(parseAPIToForm(rule));
    }
  }, [rule]);

  if (criterias.length === 0 || rule === null) {
    return <div></div>;
  }

  return (
    <div className="shadow-md bg-white rounded-3xl py-6 w-full mt-6">
      {
        formState && <RuleForm
          initialState={formState}
          isLoading={formIsLoading}
          submitTitleButton={formIsLoading ? 'Cargando...' : 'Guardar cambios'}
          onSubmit={(form) => {
            setFormIsLoading(true);
            editRule(ruleId, {
              name: form.name,
              description: '',
              criterias: form.criterias,
            })
              .then((response) => {
                if (!response.error) {
                  navigate('/rules', {
                    state: {
                      message: {
                        message: 'Regla actualizada con éxito',
                        type: 'success',
                      },
                    },
                  });
                } else {
                  setErrMessage(response.message);
                }

              })
              .catch((e) => {
                setErrMessage(e.message);
              })
              .finally(() => {
                setFormIsLoading(false);
              });
          }}
          onCancel={() => {
            navigate('/rules');
          }}
          loadGeolocation={loadCountriesAndCities}
          loadCities={loadCities}
          loadServiceCode={loadServiceCode}
          criterias={criterias} />
      }
      <div className="mb-6">
        {errMessage && <Message message={errMessage} type={'error'} />}
      </div>
    </div>
  );
};

export default EditRuleForm;
